var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"ls_flex"},[_c('left-bar'),_c('div',{staticClass:"main"},[_c('top-bar',{on:{"load":function($event){_vm.loaded = true}}}),(_vm.loaded)?_c('div',{staticStyle:{"padding-bottom":"40px"}},[_c('router-view')],1):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }